module.exports = __webpack_public_path__ + "static/media/in_edit_blue.30410ce6.svg";